import axios from "axios";
import React, { useEffect, useState } from "react";
import $ from "jquery";
// import Spinner from '../../Spinner';
import api from "../../../api/axiosInstance";
const FormMasterSectionCard = ({
  section,
  formMasterGuid,
  handleDeleteSection,
  shouldDisableFields,
  setRefresh,
}) => {
  debugger;
  const [selectedComponent, setSelectedComponent] = useState("");
  const [components, setComponents] = useState([]);
  const [formMasterComponents, setFormMasterComponents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [formMasterComponent, setFormMasterComponent] = useState({});
  const [id, setId] = useState("");
  const [selectedSectionId, setSelectedSectionId] = useState(null); // To store the selected section's ID
  const [columns, setColumns] = useState(""); // To store the value of "No. of Columns" in the modal
  const [sectionModalVisible, setSectionModalVisible] = useState(false);
  const [reOrdering, setReOrdering] = useState(false);
  // Modal and form data states
  const [modalVisible, setModalVisible] = useState(false);
  const [componentData, setComponentData] = useState({
    label: "",
    mandatory: false,
    redBtnoptions: Array(30).fill(""),
    chboxoptions: Array(30).fill(""),
    listboxoptions: Array(30).fill(""), // For options like radio buttons, checkboxes, etc.
    tableLabel: "",
    tableColumns: Array(6).fill(""), // Adjust this to match the number of headers you need
    tableRows: 0, // Capture the number of rows input
    header: "",
    singleLineTextboxLabel: "",
    multiLineTextboxLabel: "",
    dateTextboxLabel: "",
    numberTextboxLabel: "",
    subHeader: "",
  });
  const [textInput, setTextInput] = useState("");

  // 1. Better initialization with cleanup
  const initializeEvents = () => {
    if (window.$ && window.$.ui) {
      const tableId = `#tblComponents-${section.seqNo}`;

      // Destroy existing sortable if it exists
      if (window.$(tableId).hasClass("ui-sortable")) {
        window.$(tableId).sortable("destroy");
      }

      window.$(tableId).sortable({
        items: "tbody tr", // More specific selector
        cursor: "move",
        axis: "y",
        handle: "td", // Allow dragging by clicking on any cell
        dropOnEmpty: false,
        placeholder: "ui-state-highlight", // Add visual placeholder
        start: function (e, ui) {
          ui.item.addClass("selected");
        },
        stop: function (e, ui) {
          ui.item.removeClass("selected");
        },
        update: function (event, ui) {
          // Optional: Auto-trigger reorder when drag stops
          console.log("Order changed, consider auto-saving");
        },
      });
    } else {
      console.error("jQuery UI sortable not available");
    }
  };

  // Fetch FormMasterComponents on mount
  const fetchFormMasterComponents = () => {
    const url = `/FormMaster/GetFormMasterComponents?formMasterGuid=${formMasterGuid}&formMasterSectionGuid=${section.id}`;
   api
      .get(url)
      .then((response) => {
        debugger;
        setFormMasterComponents(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
      });
  };

  useEffect(() => {
    fetchFormMasterComponents();
    initializeEvents();
  }, []);

  // Handle the component selection change (without showing the modal immediately)
  const handleComponentChange = (e) => {
    debugger;
    setSelectedComponent(e.target.value);
    debugger;

    // Reset component data for new component
    if (e.target.value === "9") {
      // alert("9");
      debugger;
      setComponentData({
        label: "",
        mandatory: false,
        redBtnoptions: Array(30).fill(""),
        tableLabel: "",
        tableColumns: Array(6).fill(""),
        tableRows: 0,
      });
    }

    if (e.target.value === "10") {
      //  alert('10');
      debugger;
      setComponentData({
        label: "",
        mandatory: false,
        chboxoptions: Array(30).fill(""),
        tableLabel: "",
        tableColumns: Array(6).fill(""),
        tableRows: 0,
      });
    }
    if (e.target.value === "11") {
      //  alert('11');
      debugger;
      setComponentData({
        label: "",
        mandatory: false,
        listboxoptions: Array(30).fill(""),
        tableLabel: "",
        tableColumns: Array(6).fill(""),
        tableRows: 0,
      });
    }
    debugger;
  };

  const typeValueMapping = {
    121440004: 0, // Only Text
    121440000: 1, // Spacer
    121440001: 2, // Line Break
    121440002: 3, // Header
    121440003: 4, // Sub-Header
    121440005: 5, // Label & Single Line Textbox
    121440006: 6, // Label & Multiline Textbox
    121440007: 7, // Label & Date Textbox
    121440008: 8, // Label & Number Textbox
    121440009: 9, // Label & Radio Buttons
    121440010: 10, // Label & Checkboxes
    121440011: 11, // Label & Listbox
    121440012: 12, // Table
    121440013: 13, // Image
  };

  // Get component name based on ID
  const getComponentName = (componentId) => {
    switch (componentId) {
      case "0":
        return "Only Text";
      case "1":
        return "Spacer";
      case "2":
        return "Line Break";
      case "3":
        return "Header";
      case "4":
        return "Sub-Header";
      case "5":
        return "Label & Single Line Textbox";
      case "6":
        return "Label & Multiline Textbox";
      case "7":
        return "Label & Date Textbox";
      case "8":
        return "Label & Number Textbox";
      case "9":
        return "Label & Radio Buttons";
      case "10":
        return "Label & Checkboxes";
      case "11":
        return "Label & Listbox";
      case "12":
        return "Table";
      case "13":
        return "Image";
      default:
        return "";
    }
  };

  // Handle the modal form input change
  const handleInputChange = (e) => {
    debugger;
    const { name, value } = e.target;
    setComponentData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    debugger;
  };

  const handleTableColumnChange = (e, index) => {
    debugger;
    const { value } = e.target;
    const newColumns = [...componentData.tableColumns];
    newColumns[index] = value;
    setComponentData((prevData) => ({
      ...prevData,
      tableColumns: newColumns,
    }));
  };
  const handleOptionChange = (e, index) => {
    debugger;
    const { value } = e.target;
    const select = Number(selectedComponent);
    if (select === 9) {
      debugger;
      const newOptions = [...componentData.redBtnoptions];
      newOptions[index] = value;
      setComponentData((prevData) => ({
        ...prevData,
        redBtnoptions: newOptions,
        chboxoptions: Array(30).fill(""),
        listboxoptions: Array(30).fill(""),
      }));
    }
    if (select === 10) {
      // alert("10");
      debugger;
      const newOptions = [...componentData.chboxoptions];
      newOptions[index] = value;
      setComponentData((prevData) => ({
        ...prevData,
        chboxoptions: newOptions,
        redBtnoptions: Array(30).fill(""),
        listboxoptions: Array(30).fill(""),
      }));
    }
    if (select === 11) {
      const newOptions = [...componentData.listboxoptions];
      newOptions[index] = value;
      setComponentData((prevData) => ({
        ...prevData,
        listboxoptions: newOptions,
        redBtnoptions: Array(30).fill(""),
        chboxoptions: Array(30).fill(""),
      }));
    }

    debugger;
  };

const createOptionFields = (prefix, options) => {
  const newComponent = {};

  // 1. Filter out all empty or null strings so only filled values remain
  const filledOptions = options.filter(
    (opt) => opt !== null && opt !== undefined && opt.trim() !== ""
  );

  // 2. Pre-initialize all 30 possible labels to empty strings 
  // This ensures old data is cleared if you are editing/overwriting
  for (let i = 1; i <= 30; i++) {
    newComponent[`${prefix}Opt${i}Label`] = "";
  }

  // 3. Map the filled options sequentially to the keys
  filledOptions.forEach((option, index) => {
    const key = `${prefix}Opt${index + 1}Label`;
    newComponent[key] = option; 
  });

  return newComponent;
};
  const validateBeforeSubmit = () => {
    debugger;
    const type = Number(selectedComponent);

    // 0 = Only Text
    if (type === 0) {
      if (!textInput || textInput.trim() === "") {
         $.alert({
          title: "",
          content: "Please fill the required fields.",
          type: "red",
        });
        return false;
      }
    }

    // 3 = Header
    if (type === 3) {
      if (!componentData.header || componentData.header.trim() === "") {
       $.alert({
          title: "",
          content: "Please fill the required fields.",
          type: "red",
        });
        return false;
      }
    }

    // 4 = Sub Header
    if (type === 4) {
      if (!componentData.subHeader || componentData.subHeader.trim() === "") {
       $.alert({
          title: "",
          content: "Please fill the required fields.",
          type: "red",
        });
        return false;
      }
    }

    // 5 = Single Line Textbox
    if (type === 5) {
      if (!componentData.singleLineTextboxLabel) {
        $.alert({
          title: "",
          content: "Please fill the required fields.",
          type: "red",
        });
        return false;
      }
    }

    // 6 = Multiline Textbox
    if (type === 6) {
      if (!componentData.multiLineTextboxLabel) {
  $.alert({
          title: "",
          content: "Please fill the required fields.",
          type: "red",
        });
        return false;
      }
      if (
        !componentData.multilineTextboxRows ||
        componentData.multilineTextboxRows <= 0
      ) {
   $.alert({
          title: "",
          content: "Please fill the required fields.",
          type: "red",
        });
        return false;
      }
    }

    // 7 = Date Textbox
    if (type === 7) {
      if (!componentData.dateTextboxLabel.trim()) {
          $.alert({
          title: "",
          content: "Please fill the required fields.",
          type: "red",
        });
        return false;
      }
    }

    // 8 = Number Textbox
    if (type === 8) {
      if (!componentData.numberValue) {
        $.alert({
          title: "",
          content: "Please fill the required fields.",
          type: "red",
        });
        return false;
      }
    }

    // 9 = Radio Buttons
    if (type === 9) {
      debugger;
      const options = componentData.redBtnoptions.filter(
        (opt) => opt.trim() !== ""
      );
      if ((componentData.redBtnoptions[0].trim()=== "") || (!componentData.label || componentData.label.trim() === "")){
         $.alert({
          title: "",
          content: "Please fill the required fields.",
          type: "red",
        });
        return false;
      }
    }

    // 10 = Checkbox
    if (type === 10) {
      const options = componentData.chboxoptions.filter(
        (opt) => opt.trim() !== ""
      );
      if ((componentData.chboxoptions[0].trim()=== "") ||(!componentData.label || componentData.label.trim() === "")){
            $.alert({
          title: "",
          content: "Please fill the required fields.",
          type: "red",
        });
        return false;
      }
    
    }

    // 11 = Listbox
    if (type === 11) {
      const options = componentData.listboxoptions.filter(
        (opt) => opt.trim() !== ""
      );
      if ((componentData.listboxoptions[0].trim()=== "") || (!componentData.label || componentData.label.trim() === "")) {
         $.alert({
          title: "",
          content: "Please fill the required fields.",
          type: "red",
        });
        return false;
      }
    }

    // 12 = Table
    if (type === 12) {
          const headers = componentData?.tableColumns?.filter((h) =>( h?.trim() !== " " )&&  (h !==null));
      if ((!componentData?.tableLabel.trim())||(headers?.length < 1) || (componentData.tableRows < 1))  {
            $.alert({
          title: "",
          content: "Please fill the required fields.",
          type: "red",
        });
        return false;
      }
    }

    return true; // ✔ All validation passed
  };
  const normalizeTableColumns = (columns, max = 6) => {
  const cleaned = columns.filter(c => c && c.trim() !== "");
  while (cleaned.length < max) {
    cleaned.push("");
  }
  return cleaned.slice(0, max);
};


  // Submit form data and close modal
const handleSubmit = () => {
  debugger;
  const componetdata = componentData;
  const formMaster = formMasterComponents;
  console.log("component Data is=>", componetdata);
  debugger;
  const normalizedColumns = normalizeTableColumns(
  componentData.tableColumns || []
);

  const component = {
    id: id || "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    name: componentData?.label || "",
    formMasterId: formMasterGuid || "",
    formMasterName: "string",
    formMasterSectionId: section?.id || "",
    formMasterSectionName: "string",
    seqNo: 1,
    multilineTextboxRows: componentData?.multilineTextboxRows || 0,
    tableRows: componentData?.tableRows || 0,
    typeValue: Number(selectedComponent) || 0,
    typeText: "string",
    isMandatory: componentData?.mandatory || false,
    header: componentData?.header || "",
    subHeader: componentData?.subHeader || "",
    singleLineTextboxLabel: componentData?.singleLineTextboxLabel || "",
    multilineTextboxLabel: componentData?.multiLineTextboxLabel || "",
    dateTextboxLabel: componentData?.dateTextboxLabel || "",
    numberTextboxLabel: componentData?.numberValue || "",
    radioButtonsLabel: "string",
    checkboxesLabel: "string",
    listboxLabel: "string",
    tableLabel: componentData?.tableLabel || "",
   tableHeader1: normalizedColumns[0] || "",
  tableHeader2: normalizedColumns[1] || "",
  tableHeader3: normalizedColumns[2] || "",
  tableHeader4: normalizedColumns[3] || "",
  tableHeader5: normalizedColumns[4] || "",
  tableHeader6: normalizedColumns[5] || "",
    onlyText: textInput || "",

    // 🔘 RADIO BUTTON OPTIONS
    // 🔘 RADIO BUTTON OPTIONS
    Options: [],
    OnlyTextParas: [],
  };
  console.log("component", component);

  debugger;
  let updatedComponent = {};
  debugger;

  if (selectedComponent === 0) {
    updatedComponent.onlyText = component.onlyText;
  }
  if (selectedComponent === "3") {
    // singleLine Textbox
    updatedComponent.header = componentData.header; // Assuming you store the value for singleline textbox
  }
  if (selectedComponent === "4") {
    // singleLine Textbox
    // updatedComponent.subHeader = componentData.subHeader; // Assuming you store the value for singleline textbox
  }
  if (selectedComponent === "5") {
    // singleLine Textbox
    updatedComponent.singleLineTextboxLabel =
      componentData.singleLineTextboxLabel; // Assuming you store the value for singleline textbox
  }
  // Add conditionally the additional data based on the selected component type
  if (selectedComponent === "6") {
    // Multiline Textbox
    updatedComponent.multilineTextboxLabel =
      componentData.multiLineTextboxLabel; // Assuming you store the value for multiline textbox
    updatedComponent.multilineTextboxRows =
      componentData.multilineTextboxRows;
  }
  // Add other conditions for different component types if needed
  else if (selectedComponent === "7") {
    // Date Textbox
    updatedComponent.dateTextboxLabel = componentData.dateTextboxLabel; // Add relevant field for Date Textbox
  } else if (selectedComponent === "8") {
    // Number Textbox
    updatedComponent.numberTextboxLabel = componentData.numberValue; // Add relevant field for Number Textbox
  }
  // Check the selected component and handle accordingly
if (selectedComponent === "9") {
    component.radioButtonsLabel = componentData.label;
    // This now returns an object with sequential keys Opt1, Opt2, etc.
    updatedComponent = createOptionFields("radioButton", componentData.redBtnoptions);
  } else if (selectedComponent === "10") {
    component.checkboxesLabel = componentData.label;
    updatedComponent = createOptionFields("checkbox", componentData.chboxoptions);
  } else if (selectedComponent === "11") {
    component.listboxLabel = componentData.label;
    updatedComponent = createOptionFields("listbox", componentData.listboxoptions);
  }

  if (!validateBeforeSubmit()) {
    debugger;
    return; // ❌ Stop if validation fails
  }

  // Merge the updated component (with dynamic keys) with the static component data
  const finalComponent = { ...component, ...updatedComponent };
  console.log("Final component:", finalComponent);
  debugger;
  // Make the POST request with the final component
  $.confirm({
    title: "Confirm Creation",
    content: "Are you sure you want to create this record?",
    type: "green",
    buttons: {
      yes: {
        text: "Yes",
        btnClass: "btn-green",
        action: function () {
          debugger;
        api
            .post(
              "/FormMaster/AddFormMasterComponents",
              finalComponent,
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            )
            .then((response) => {
              debugger;
            //  onUpdated();
            setRefresh();
             //
              // Show success alert
              $.alert({
                title: "Success",
                content: "Record saved successfully",
                type: "green",
              });

              setModalVisible(false);
              // Hide the modal programmatically
              const modal = document.getElementById("modal-default");
              modal.style.display = "none"; // Close the modal

              const backdrop = document.querySelector(".modal-backdrop");
              if (backdrop) {
                backdrop.remove();
              }
              // Reset the component data to empty values
              setComponentData({
                label: "",
                mandatory: false,
                options: Array(30).fill(""),
                tableLabel: "",
                tableColumns: Array(6).fill(""),
                tableRows: 0,
              });
              setId("");
              setTextInput("");
              debugger;
              // Reset selected component type
              setSelectedComponent("");
              fetchFormMasterComponents();
            })
            .catch((error) => {
              debugger;
              console.error(
                "Error adding component:",
                error.response ? error.response.data : error.message
              );
              alert(
                "Error: " +
                  (error.response
                    ? JSON.stringify(error.response.data)
                    : error.message)
              );
            });
        },
      },
      no: {
        text: "No",
        btnClass: "btn-red",
        action: function () {
          // If user clicks 'No', do nothing
          console.log("Creation canceled");
        },
      },
    },
  });
};
  const deleteFormMasterComponent = (formMasterComponentId) => {
    // Show confirmation dialog before deleting
    $.confirm({
      title: "Are you sure?",
      content: "Do you really want to delete this record?",
      type: "red",
      buttons: {
        yes: {
          text: "Yes",
          btnClass: "btn-red",
          action: () => {
            // Construct the URL with query parameters
            const url = `/FormMaster/DeleteFormMasterComponent?formMasterComponentId=${formMasterComponentId}&formMasterSectionId=${section.id}`;

            // Send the DELETE request with the query parameters
           api
              .delete(url)
              .then((response) => {
                // Handle the response (updated list of form master components)
                console.log(
                  "Updated Form Master Components:",
                  response.data.formMasterComponents
                );
              setRefresh(true);

                // Show success message on successful deletion
                $.alert({
                  title: "Success",
                  content: "Record deleted successfully.",
                  type: "green",
                });

                // Optionally, refresh the list or re-fetch the data
                fetchFormMasterComponents();
              })
              .catch((error) => {
                debugger;
                // Handle errors and show error message on failure
                console.error(
                  "Error deleting component:",
                  error.response ? error.response.data : error.message
                );

                $.alert({
                  title: "Error",
                  content:
                    "Failed to delete the record." + error.response
                      ? error.response.data
                      : error.message,
                  type: "red",
                });
              });
          },
        },
        no: {
          text: "No",
          btnClass: "btn-default",
          action: function () {
            // If "No" is clicked, do nothing and just close the confirmation
          },
        },
      },
    });
  };
  const handleEditButtonClick = (componentId) => {
    debugger;
    setId(componentId);
    // Fetch component data when the "Edit" button is clicked
    fetchFormMasterComponent(componentId);
  };
  const fetchFormMasterComponent = (formMasterComponentId) => {
    debugger;
    const url = `/FormMaster/GetFormMasterComponent?formMasterComponentId=${formMasterComponentId}`;
    api
      .get(url)
      .then((response) => {
        debugger;
        console.log(response);

        const component = response.data;
        debugger;
        // Reset componentData with the fetched values
        const updatedComponentData = {
          label: component.label || "", // If label is present in the response
          mandatory: component.isMandatory || false, // Assuming `isMandatory` comes from the response
          redBtnoptions: component.options || Array(30).fill(""), // Assuming options could come from the response
          chboxoptions: component.options || Array(30).fill(""), // Assuming options could come from the response
          listboxoptions: component.options || Array(30).fill(""), // Assuming options could come from the response
          tableLabel: component.tableLabel || "",
          tableColumns: component.tableColumns || Array(6).fill(""), // Fill with default columns if not available
          tableRows: component.tableRows || 0, // Set the number of rows for the table
          header: component.header || "",
          singleLineTextboxLabel: component.singleLineTextboxLabel || "",
          multiLineTextboxLabel: component.multilineTextboxLabel || "",
          multilineTextboxRows: component.multilineTextboxRows || "",
          dateTextboxLabel: component.dateTextboxLabel || "",
          numberTextboxLabel: component.numberTextboxLabel || "",
          subHeader: component.subHeader || "", // Default to empty if not available
          onlyText: component.onlyText || "",
        };
        // Dynamically set the options based on typeValue
        switch (component.typeValue) {
          case 121440002: // Header
            updatedComponentData.header = component.header;
            break;
          case 121440003: // sub-header
            updatedComponentData.subHeader = component.subHeader;
            break;
          case 121440012: // Table - No options to fill
            updatedComponentData.tableRows = component.tableRows;
            updatedComponentData.tableColumns = [
              component.tableHeader1,
              component.tableHeader2,
              component.tableHeader3,
              component.tableHeader4,
              component.tableHeader5,
              component.tableHeader6,
            ];
            debugger;
            break;

          case 121440011: // Listbox - Fill 30 options from ListboxOpt1Label to ListboxOpt30Label
            updatedComponentData.label = component.listboxLabel;
            // Dynamically fill 30 options for Listbox
            debugger;
            updatedComponentData.listboxoptions = Array.from(
              { length: 30 },
              (_, index) => {
                const optionKey = `listboxOpt${index + 1}Label`;
                return component[optionKey] || ""; // Access the option dynamically
              }
            );
            break;

          case 121440010: // Checkbox - Fill 30 options from CheckboxOpt1Label to CheckboxOpt30Label
            updatedComponentData.label = component.checkboxesLabel;
            // Dynamically fill 30 options for Checkbox
            debugger;
            updatedComponentData.chboxoptions = Array.from(
              { length: 30 },
              (_, index) => {
                const optionKey = `checkboxOpt${index + 1}Label`;
                return component[optionKey] || ""; // Access the option dynamically
              }
            );
            debugger;
            break;

          case 121440009: // Radio Buttons - Fill 30 options from RadioButtonOpt1Label to RadioButtonOpt30Label
            updatedComponentData.label = component.radioButtonsLabel;
            // Dynamically fill 30 options for Radio buttons
            debugger;
            updatedComponentData.redBtnoptions = Array.from(
              { length: 30 },
              (_, index) => {
                const optionKey = `radioButtonOpt${index + 1}Label`;
                return component[optionKey] || ""; // Access the option dynamically
              }
            );
            debugger;
            break;

          case 121440004: //onlyText
            setTextInput(component.onlyText);
            break;
          case 121440005: //singleLine
            updatedComponentData.singleLineTextboxLabel =
              component.singleLineTextboxLabel;

            break;
          case 121440006: //multiline
            updatedComponentData.multiLineTextboxLabel =
              component.multilineTextboxLabel;
            updatedComponentData.multilineTextboxRows =
              component.multilineTextboxRows;
            break;
          case 121440007: //date
            updatedComponentData.dateValue = component.dateTextboxLabel;

            break;
          case 121440008: //number
            updatedComponentData.numberValue = component.numberTextboxLabel;

            break;
          default:
            // Handle other types if necessary
            break;
        }

        // Set the updated data into the state
        setComponentData(updatedComponentData);

        // Map the type value to the frontend component type
        const frontendValue = (typeValueMapping[component.typeValue]).toString();
        
        setSelectedComponent(frontendValue); // Update selectedComponent to frontend type

        // Ensure modal is visible after data is set
        setModalVisible(true);
        const modal = document.getElementById("modal-default");

        // Remove existing backdrop if any
        const existingBackdrop = document.querySelector(".modal-backdrop");
        if (existingBackdrop) {
          existingBackdrop.remove();
        }

        // Create a new backdrop element
        const backdrop = document.createElement("div");
        backdrop.classList.add("modal-backdrop", "fade", "show");
        document.body.appendChild(backdrop);

        // Show the modal by changing its display to block
        modal.style.display = "block";

        // Optionally, add any animations or transitions to the modal or backdrop if needed
        setTimeout(() => {
          backdrop.classList.add("show");
        }, 10);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
      });
  };
  // const EditFormMasterComponent = (formMasterComponentId) => {
  //   // Show confirmation dialog before deleting
  //   $.confirm({
  //     title: 'Are you sure?',
  //     content: 'Do you really want to save changes ?',
  //     tye: 'red',
  //     buttons: {
  //       yes: {
  //         text: 'Yes',
  //         btnClass: 'btn-red',
  //         action: () => {
  //           // Construct the URL with query parameters
  //           const url = `/FormMaster/EditFormMasterComponent?formMasterComponentId=${formMasterComponentId}`;

  //           // Send the DELETE request with the query parameters
  //           api.put(url)
  //             .then(response => {
  //               // Handle the response (updated list of form master components)
  //               console.log('Updated Form Master Components:', response.data.formMasterComponents);

  //               // Show success message on successful deletion
  //               $.alert({
  //                 title: 'Success',
  //                 content: 'Record deleted successfully.',
  //                 type: 'green'
  //               });

  //               // Optionally, refresh the list or re-fetch the data
  //               fetchFormMasterComponents();
  //             })
  //             .catch(error => {
  //               // Handle errors and show error message on failure
  //               console.error('Error deleting component:', error.response ? error.response.data : error.message);

  //               $.alert({
  //                 title: 'Error',
  //                 content: 'Failed to delete the record.',
  //                 type: 'red'
  //               });
  //             });
  //         }
  //       },
  //       no: {
  //         text: 'No',
  //         btnClass: 'btn-default',
  //         action: function () {
  //           // If "No" is clicked, do nothing and just close the confirmation
  //         }
  //       }
  //     }
  //   });
  // };
  const handleCloseModal = () => {
    if (id !== null && id !== "") {
      // Reset the dropdown to the default option when id is not null
      setSelectedComponent("");
    }
    // Close the modal (you already have the logic for that)
    setModalVisible(false);
    const modal = document.getElementById("modal-default");
    modal.style.display = "none"; // Close the modal
    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) {
      backdrop.remove();
    }
    setId("");
  };
  const handleCloseSectionModal = () => {
    setSelectedSectionId(null); // Reset selected section ID
    setColumns(""); // Reset columns input field
    setSectionModalVisible(false); // Close the modal
  };
  const handleEditSection = (sectionId, noOfColumns) => {
    debugger;
    setSelectedSectionId(sectionId);

    setColumns(noOfColumns); // Set initial value of columns from section data
    setSectionModalVisible(true);
  };

  // Handle saving changes
  const handleSectionSaveChanges = () => {
    debugger;

    if (columns > 4 || columns < 0) {
      alert("Column range can only be from 0 to 4");
    } else {
      if (selectedSectionId !== null && columns) {
        const updatedData = {
          sectionId: selectedSectionId, // ID of the selected section
          noOfColumns: columns, // Updated number of columns
        };

        const headers = {
          "Content-Type": "application/json", // Sending data as JSON
          // Expecting a JSON response
        };
        // Send the updated section data to the backend using Axios
       api
          .put(
            "/FormMaster/UpdateFormMasterSection",
            updatedData,
            { headers }
          )
          .then((response) => {
            // Assuming the server returns a success message or status
            $.alert({
              title: "Success",
              content: "Record saved successfully",
              type: "green",
            });
            console.log("Section updated successfully:", response.data);
            section.noOfColumns = columns;
            setSectionModalVisible(false);
            setColumns("");
            // Reset the form fields and close the modal
            setSelectedSectionId(null); // Reset selected section ID
            setColumns(""); // Reset columns input field

            // Optionally close the modal here if needed
          })
          .catch((error) => {
            // Handle error here
            console.error("Error updating section:", error);
          });
      } else {
        console.error("No section selected or columns not set");
      }
    }
  };

  // 2. Better useEffect handling
  useEffect(() => {
    if (formMasterComponents.length > 0 && !reOrdering) {
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        initializeEvents();
      }, 100);
    }

    return () => {
      // Cleanup on unmount
      if (window.$ && window.$.ui) {
        const tableId = `#tblComponents-${section.seqNo}`;
        if (window.$(tableId).hasClass("ui-sortable")) {
          window.$(tableId).sortable("destroy");
        }
      }
    };
  }, [formMasterComponents, section.seqNo, reOrdering]);

  // 3. Improved handleReOrder function
  const handleReOrder = (tblId) => {
    debugger;
    if (!window.$) {
      alert("jQuery is not available");
      return;
    }

    setReOrdering(true);
    const components = [];
    let counter = 1; // Start from 1 for sequence numbers

    // Use more specific selector
    $(`#${tblId} tbody tr`).each(function () {
      const id = $(this).attr("data-component-guid");
      const name = $(this).attr("data-component-name");

      if (id && name) {
        // Ensure data exists
        components.push({
          id: id,
          name: name,
          seqNo: counter,
        });
        counter++;
      }
    });

    if (components.length === 0) {
      alert("No components found to reorder");
      setReOrdering(false);
      return;
    }

    console.log("Components to reorder:", components);

    // Show loading state
    const tableElement = document.getElementById(tblId);
    if (tableElement) {
      tableElement.style.opacity = "0.5";
      tableElement.style.pointerEvents = "none";
    }

    api
      .post(
        `/FormMaster/UpdateOrderOfComponents?formMasterSectionGuidStr=${section.id}`,
        components,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        console.log("Reorder successful:", response.data);
        setFormMasterComponents(response.data);
        // alert("Components re-ordered successfully!");
        $.confirm({
          title: "",
          content: "Components re-ordered successfully!",
          buttons: {
            confirm: {
              text: "Yes",
              btnClass: "btn-success",
            },
          },
        });
      })
      .catch((error) => {
        console.error("Reorder failed:", error);
        alert(
          `Error reordering components: ${
            error.response?.data || error.message
          }`
        );
      })
      .finally(() => {
        setReOrdering(false);
        if (tableElement) {
          tableElement.style.opacity = "1";
          tableElement.style.pointerEvents = "auto";
        }
      });
  };

  const reorderingStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100px",
    fontSize: "24px",
    fontWeight: "bold",
    color: "#f39c12", // Color for the text
  };

  // 4. Add CSS for better visual feedback (add this to your CSS file)
  const sortableStyles = `
  .ui-sortable-helper {
    background-color: #f8f9fa;
    border: 2px dashed #007bff;
    opacity: 0.8;
  }
  
  .ui-state-highlight {
    height: 50px;
    background-color: #e3f2fd;
    border: 2px dashed #2196f3;
  }
  
  .ui-sortable tr.selected {
    background-color: #fff3cd;
    border: 1px solid #ffeaa7;
  }
  
  .ui-sortable {
    cursor: move;
  }
  
  .ui-sortable tr:hover {
    background-color: #f5f5f5;
  }
`;

  const debugReordering = () => {
    console.log("=== Reordering Debug Info ===");
    console.log("jQuery available:", !!window.$);
    console.log("jQuery UI available:", !!(window.$ && window.$.ui));
    console.log("Section seqNo:", section.seqNo);
    console.log("Table ID:", `tblComponents-${section.seqNo}`);
    console.log("Components count:", formMasterComponents.length);
    console.log("Should disable fields:", shouldDisableFields);
    console.log("Currently reordering:", reOrdering);

    const tableElement = document.getElementById(
      `tblComponents-${section.seqNo}`
    );
    console.log("Table element exists:", !!tableElement);

    if (tableElement) {
      const rows = tableElement.querySelectorAll("tbody tr");
      console.log("Table rows count:", rows.length);
      rows.forEach((row, index) => {
        console.log(`Row ${index}:`, {
          guid: row.getAttribute("data-component-guid"),
          name: row.getAttribute("data-component-name"),
        });
      });
    }
  };

  // Render the modal content based on selected component
  const renderModalContent = () => {
    const obj = selectedComponent;
    // alert('renderModal');
    debugger;
    switch (selectedComponent) {
      case "3": // Header
      case "4": // Sub-Header
        return (
          <>
            <div className="form-group">
              <label> {getComponentName(selectedComponent)} </label>
                <span style={{ color: "red" }}> *</span>
              {selectedComponent === "3" && (
                <input
                  type="text"
                  name="header"
                  value={componentData.header || ""}
                  onChange={handleInputChange}
                  className="form-control"
                  maxLength={200}
                  required
                />
              )}
              {selectedComponent === "4" && (
                <input
                  type="text"
                  name="subHeader"
                  value={componentData.subHeader || ""}
                  onChange={handleInputChange}
                  className="form-control"
                  required
                />
              )}
            </div>
          </>
        );

      case "5": // Textbox (Label & Single Line Textbox)
      case "6": // Textbox (Label & Multiline Textbox)
      case "7": // Textbox (Label & Date Textbox)
      case "8": // Textbox (Label & Number Textbox)
        return (
          <>
            <div className="form-group">
              <label>
             
                {/* {getComponentName(selectedComponent)}  */}
              </label>

              {selectedComponent === "5" && ( // Singleline Textbox
                <div className="form-group">
                  <label> Label for SingleLine Textbox </label>
                  <span style={{ color: "red" }}> *</span>
                  <input
                    name="singleLineTextboxLabel"
                    type="text"
                    value={componentData.singleLineTextboxLabel || ""}
                    onChange={handleInputChange}
                    className="form-control"
                    maxLength={100}
                  />
                </div>
              )}

              {selectedComponent === "6" && ( // Multiline Textbox
                <div className="form-group">
                  <label>Label for Multiline Textbox </label>
                    <span style={{ color: "red" }}> *</span>
                  <input
                    name="multiLineTextboxLabel"
                    type="text"
                    value={componentData.multiLineTextboxLabel || ""}
                    onChange={handleInputChange}
                    className="form-control"
                      maxLength={200}
                  />
                  <label>Number of rows</label>
                    <span style={{ color: "red" }}> *</span>
                  <input
                    type="number"
                    name="multilineTextboxRows"
                    value={componentData.multilineTextboxRows || ""}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              )}

              {selectedComponent === "7" && ( // Date Textbox
                <div className="form-group">
                  <label>Label for Date</label>
                    <span style={{ color: "red" }}> *</span>
                  <input
                    type="text"
                    name="dateTextboxLabel"
                    value={componentData.dateTextboxLabel || ""}
                    onChange={handleInputChange}
                    className="form-control"
                      maxLength={200}
                  />
                </div>
              )}

              {selectedComponent === "8" && ( // Number Textbox
                <div className="form-group">
                  <label>Label for Number </label>
                    <span style={{ color: "red" }}> *</span>
                  <input
                    type="text"
                    name="numberValue"
                    value={componentData.numberValue || ""}
                    onChange={handleInputChange}
                    className="form-control"
                     maxLength={100}
                  />
                </div>
              )}
            </div>
            <div className="form-group">
              <label>Is Mandatory</label>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <input
                type="checkbox"
                name="mandatory"
                checked={componentData.mandatory}
                onChange={(e) =>
                  setComponentData({
                    ...componentData,
                    mandatory: e.target.checked,
                  })
                }
                className="form-check-input"
              />
            </div>
          </>
        );

      case "9": // Radio Buttons
      case "10": // Checkboxes
      case "11": // Listbox
        return (
          <>
            <div className="form-group">
              <label> Label</label>
                <span style={{ color: "red" }}> *</span>
              <input
                type="text"
                name="label"
                value={componentData.label}
                onChange={handleInputChange}
                className="form-control"
                required
                maxLength={200}
              />
            </div>
            {selectedComponent === "9" && (
              <div className="row">
                {componentData.redBtnoptions.map((option, index) => (
                  <div className="col-md-4" key={index}>
                    {" "}
                    {/* 4 columns per row (3 inputs per row) */}
                    <div className="form-group">
                      <label>Option {index + 1}</label>
                      {index=== 0 ?   <span style={{ color: "red" }}> *</span>:""}
                      <input
                        type="text"
                        value={option}
                        onChange={(e) => handleOptionChange(e, index)}
                        className="form-control"
                        maxLength={200}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}

            {selectedComponent === "10" && (
              <div className="row">
                {componentData.chboxoptions.map((option, index) => (
                  <div className="col-md-4" key={index}>
                    {" "}
                    {/* 4 columns per row (3 inputs per row) */}
                    <div className="form-group">
                      <label>Option {index + 1}</label>
                       {index=== 0 ?   <span style={{ color: "red" }}> *</span>:""}
                      <input
                        type="text"
                        value={option}
                        onChange={(e) => handleOptionChange(e, index)}
                        className="form-control"
                        maxLength={200}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}
            {selectedComponent === "11" && (
              <div className="row">
                {componentData.listboxoptions.map((option, index) => (
                  <div className="col-md-4" key={index}>
                    {" "}
                    {/* 4 columns per row (3 inputs per row) */}
                    <div className="form-group">
                      <label>Option {index + 1}</label>
                       {index=== 0 ?   <span style={{ color: "red" }}> *</span>:""}
                      <input
                        type="text"
                        value={option}
                        onChange={(e) => handleOptionChange(e, index)}
                        className="form-control"
                        maxLength={200}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        );

      case "0": // Only Text
        debugger;
        return (
          <div className="form-group">
            <label>Text</label>
              <span style={{ color: "red" }}> *</span>
            <textarea
              name="label"
              value={textInput}
              onChange={(e) => setTextInput(e.target.value)}
              placeholder="Enter your text"
              className="form-control"
              rows="4"
              required
             maxLength={200}
            />
          </div>
        );

      case "12": // Table
        return (
          <>
            <div className="form-group">
              <label>Table Label</label>
                <span style={{ color: "red" }}> *</span>
              <input
                type="text"
                name="tableLabel"
                value={componentData.tableLabel}
                onChange={handleInputChange}
                className="form-control"
                required
                maxLength={200}
              />
            </div>

            {/* Table Header Inputs - 3 per row */}
            <div className="row">
              {componentData.tableColumns.map((col, index) => (
                <div key={index} className="col-md-4">
                  {" "}
                  {/* 3 columns per row */}
                  <div className="form-group">
                    <label>Table Header {index + 1}</label>
                     {index=== 0 ?   <span style={{ color: "red" }}> *</span>:""}
                    <input
                      type="text"
                      value={col}
                      onChange={(e) => handleTableColumnChange(e, index)}
                      className="form-control"
                       maxLength={200}
                    />
                  </div>
                </div>
              ))}
            </div>

            {/* Number of Rows - Positioned on the right */}
            <div className="form-group row justify-content-center">
              <div className="col-md-4">
                <label className="col-form-label">Number of Rows</label>
                  <span style={{ color: "red" }}> *</span>
                <input
                  type="number"
                  name="tableRows"
                  value={componentData.tableRows}
                  onChange={handleInputChange}
                  className="form-control"
                  min="1"
                  required
                />
              </div>
            </div>
          </>
        );

      default:
        if (selectedComponent === 3) {
          //header
          return (
            <>
              <div className="form-group">
                <label>Label for Header</label>
                <input
                  type="text"
                  name="header"
                  value={componentData.header || ""}
                  onChange={handleInputChange}
                  className="form-control"
                  min="1"
                  required
                  maxLength={200}
                />
              </div>
            </>
          );
        }
        if (selectedComponent === 4) {
          //sub-header
          return (
            <>
              <div className="form-group">
                <label>Label for SubHeader</label>
                <input
                  type="text"
                  name="subHeader"
                  value={componentData.subHeader}
                  onChange={handleInputChange}
                  className="form-control"
                  min="1"
                  required
                  maxLength={200}
                />
              </div>
            </>
          );
        }
        if (
          selectedComponent === 11 ||
          selectedComponent === 10 ||
          selectedComponent === 9
        ) {
          //Listbox,checkbox,radio
          return (
            <>
              <div className="form-group">
                <label>Label</label>
                <input
                  type="text"
                  name="label"
                  value={componentData.label}
                  onChange={handleInputChange}
                  className="form-control"
                  required
                  maxLength={200}
                />
              </div>
              {selectedComponent === 9 && (
                <div className="row">
                  {componentData.redBtnoptions.map((option, index) => (
                    <div className="col-md-4" key={index}>
                      {" "}
                      {/* 4 columns per row (3 inputs per row) */}
                      <div className="form-group">
                        <label>Option {index + 1}</label>
                        <input
                          type="text"
                          value={option}
                          onChange={(e) => handleOptionChange(e, index)}
                          className="form-control"                                                                               
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {selectedComponent === 10 && (
                <div className="row">
                  {componentData.chboxoptions.map((option, index) => (
                    <div className="col-md-4" key={index}>
                      {" "}
                      {/* 4 columns per row (3 inputs per row) */}
                      <div className="form-group">
                        <label>Option {index + 1}</label>
                        <input
                          type="text"
                          value={option}
                          onChange={(e) => handleOptionChange(e, index)}
                          className="form-control"
                            maxLength={200}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {selectedComponent === 11 && (
                <div className="row">
                  {componentData.listboxoptions.map((option, index) => (
                    <div className="col-md-4" key={index}>
                      {" "}
                      {/* 4 columns per row (3 inputs per row) */}
                      <div className="form-group">
                        <label>Option {index + 1}</label>
                        <input
                          type="text"
                          value={option}
                          onChange={(e) => handleOptionChange(e, index)}
                          className="form-control"
                            maxLength={200}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          );
        }
        if (selectedComponent === 12) {
          //Table
          return (
            <>
              {/* Table Label - First Row */}
              <div className="form-group">
                <label>Table Label</label>
                <input
                  type="text"
                  name="tableLabel"
                  value={componentData.tableLabel}
                  onChange={handleInputChange}
                  className="form-control"
                  required
                    maxLength={200}
                />
              </div>

              {/* Table Header Inputs - 3 Inputs per Row */}
              <div className="row">
                {componentData.tableColumns.map((col, index) => (
                  <div key={index} className="col-md-4">
                    {" "}
                    {/* 3 columns per row */}
                    <div className="form-group">
                      <label>Table Header {index + 1}</label>
                      <input
                        type="text"
                        value={col}
                        onChange={(e) => handleTableColumnChange(e, index)}
                        className="form-control"
                          maxLength={200}
                      />
                    </div>
                  </div>
                ))}
              </div>

              {/* Number of Rows - Last Row, Right Aligned */}
              <div className="form-group row justify-content-center">
                <div className="col-md-4">
                  {" "}
                  {/* This takes 4 columns */}
                  <label>Number of Rows</label>
                  <input
                    type="number"
                    name="tableRows"
                    value={componentData.tableRows}
                    onChange={handleInputChange}
                    className="form-control"
                    min="1"
                    required
                  />
                </div>
              </div>
            </>
          );
        }
        if (selectedComponent === 0) {
          //onlyText
          return (
            <div className="form-group">
              <label>Text</label>
              <textarea
                name="label"
                value={textInput}
                onChange={(e) => setTextInput(e.target.value)}
                placeholder="Enter your text"
                className="form-control"
                rows="4"
                required
              />
            </div>
          );
        }

        if (selectedComponent === 5) {
          return (
            <>
              <div className="form-group">
                <label>Label for {getComponentName(selectedComponent)} </label>

                <div className="form-group">
                  <label>SingleLine Textbox Value</label>
                  <input
                    name="singleLineTextboxLabel"
                    type="text"
                    value={componentData.singleLineTextboxLabel || ""}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Is Mandatory</label>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <input
                  type="checkbox"
                  name="mandatory"
                  checked={componentData.mandatory}
                  onChange={(e) =>
                    setComponentData({
                      ...componentData,
                      mandatory: e.target.checked,
                    })
                  }
                  className="form-check-input"
                />
              </div>
            </>
          );
        }
        if (selectedComponent === 6) {
          //multiline Textbox
          return (
            <>
              <div className="form-group">
                <label>Label for {getComponentName(selectedComponent)} </label>

                <div className="form-group">
                  <label>Multiline Textbox Value</label>
                  <input
                    name="multilineTextboxLabel"
                    type="text"
                    value={componentData.multiLineTextboxLabel || ""}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                  <label>No. of rows</label>
                  <input
                    type="text"
                    name="multilineTextboxRows"
                    value={componentData.multilineTextboxRows || ""}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Is Mandatory</label>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <input
                  type="checkbox"
                  name="mandatory"
                  checked={componentData.mandatory}
                  onChange={(e) =>
                    setComponentData({
                      ...componentData,
                      mandatory: e.target.checked,
                    })
                  }
                  className="form-check-input"
                />
              </div>
            </>
          );
        }
        if (selectedComponent === 7) {
          return (
            <>
              <div className="form-group">
                <label>Label for {getComponentName(selectedComponent)} </label>

                <div className="form-group">
                  <label>Date Value</label>
                  <input
                    type="text"
                    name="dateTextboxLabel"
                    value={componentData.dateTextboxLabel || ""}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Is Mandatory</label>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <input
                  type="checkbox"
                  name="mandatory"
                  checked={componentData.mandatory}
                  onChange={(e) =>
                    setComponentData({
                      ...componentData,
                      mandatory: e.target.checked,
                    })
                  }
                  className="form-check-input"
                />
              </div>
            </>
          );
        }
        if (selectedComponent === 8) {
          return (
            <>
              <div className="form-group">
                <label>Label for {getComponentName(selectedComponent)} </label>

                <div className="form-group">
                  <label>Number Value</label>
                  <input
                    type="text"
                    name="numberValue"
                    value={componentData.numberValue || ""}
                    onChange={handleInputChange}
                    className="form-control"
                    maxLength={100}
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Is Mandatory</label>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <input
                  type="checkbox"
                  name="mandatory"
                  checked={componentData.mandatory}
                  onChange={(e) =>
                    setComponentData({
                      ...componentData,
                      mandatory: e.target.checked,
                    })
                  }
                  className="form-check-input"
                />
              </div>
            </>
          );
        }
    }
  };
  // const handleTableColumnChange = (e, index) => {
  //   const newColumns = [...componentData.tableColumns];
  //   newColumns[index] = e.target.value;
  //   setComponentData((prevData) => ({
  //     ...prevData,
  //     tableColumns: newColumns,
  //   }));
  // };
  // Render loading spinner or error message if needed
  if (loading) {
    return <div>Loading components...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  const handleAddComponentClick = () => {
    if (!selectedComponent) {
      alert("Please select a component to add");
    } else {
      setId("");
      setModalVisible(true); // Show modal if component is selected

      // Hide the modal programmatically
      const modal = document.getElementById("modal-default");

      // Remove existing backdrop if any
      const existingBackdrop = document.querySelector(".modal-backdrop");
      if (existingBackdrop) {
        existingBackdrop.remove();
      }

      // Create a new backdrop element
      const backdrop = document.createElement("div");
      backdrop.classList.add("modal-backdrop", "fade", "show");
      document.body.appendChild(backdrop);

      // Show the modal by changing its display to block
      modal.style.display = "block";

      // Optionally, add any animations or transitions to the modal or backdrop if needed
      setTimeout(() => {
        backdrop.classList.add("show");
      }, 10); // Add slight delay for smooth transition if necessary
    }
  };

  return (
    <div className="card card-success mt-3">
      <div className="card-header">
        <b>
          Section - {section.seqNo} ({section.noOfColumns} Columns)
        </b>
      </div>
      <div className="card-body">
        <div className="form-group">
          <div className="row">
            {/* Left side - Dropdown and Add button */}
            <div
              className="col-md-9"
              style={{ display: "flex", alignItems: "center" }}
            >
              <select
                id="componentDropdown"
                className="form-control"
                onChange={handleComponentChange}
                value={selectedComponent}
                style={{ width: "50%" }}
                disabled={shouldDisableFields}
              >
                <option value="">-- Select Component --</option>
                                <option value="3">Header</option>
                <option value="4">Sub-Header</option>
                <option value="0">Only Text</option>
                <option value="2">Line Break</option>
                <option value="5">Label & Single Line Textbox</option>
                <option value="6">Label & Multiline Textbox</option>
                <option value="7">Label & Date Textbox</option>
                <option value="8">Label & Number Textbox</option>
                <option value="9">Label & Radio Buttons</option>
                <option value="10">Label & Checkboxes</option>
                <option value="11">Label & Listbox</option>
                <option value="12">Table</option>
                <option value="1">Spacer</option>
                {/* <option value="13">Image</option> */}
              </select>
              {selectedComponent === "1" || selectedComponent === "2" ? (
                <button
                  className="btn btn-warning"
                  data-target="#modal-lg"
                  onClick={handleSubmit}
                  style={{ marginLeft: "20px" }}
                  disabled={shouldDisableFields}
                >
                  <b>Add</b>
                </button>
              ) : (
                <button
                  className="btn btn-warning"
                  data-target="#modal-lg"
                  onClick={handleAddComponentClick}
                  style={{ marginLeft: "20px" }}
                  disabled={shouldDisableFields}
                >
                  <b>Add</b>
                </button>
              )}
            </div>

            {/* Right side - Re-Order Components and Update Section buttons */}
            <div
              className="col-md-3"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              {formMasterComponents && formMasterComponents.length > 1 ? (
                <button
                  id={`btnReOrder-${section.seqNo}`}
                  type="submit"
                  className="btn btn-warning"
                  onClick={() =>
                    handleReOrder(`tblComponents-${section.seqNo}`)
                  }
                  style={{
                    marginRight: "10px",
                    whiteSpace: "nowrap", // Prevent the button text from wrapping
                  }}
                  disabled={shouldDisableFields}
                >
                  Re-Order Components
                </button>
              ) : null}

              <button
                type="button"
                className="btn btn-success"
                data-toggle="modal"
                data-target="#modal-sm"
                onClick={() =>
                  handleEditSection(section.id, section.noOfColumns)
                }
                style={{
                  marginRight: "10px",
                  whiteSpace: "nowrap", // Prevent the button text from wrapping
                }}
                disabled={shouldDisableFields}
              >
                Update Section
              </button>

              <button
                type="button"
                className="btn btn-danger"
                onClick={() => handleDeleteSection(section.id, formMasterGuid)}
                style={{
                  whiteSpace: "nowrap", // Prevent the button text from wrapping
                }}
                disabled={shouldDisableFields}
              >
                Delete Section
              </button>
            </div>
          </div>
        </div>
        {reOrdering ? (
          <div style={reorderingStyle}>Reordering...</div> // Show this div when reordering is true
        ) : (
          <fieldset disabled={shouldDisableFields}>
            <table
              id={`tblComponents-${section.seqNo}`}
              className="table table-bordered table-striped mt-3"
            >
              <thead>
                <tr>
                  <th width="72%">Component</th>
                  <th width="6%">Seq No.</th>
                  <th width="16%">Type</th>
                  <th width="6%">Action</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(formMasterComponents) &&
                formMasterComponents.length > 0 ? (
                  formMasterComponents.map((component) => (
                    <tr
                      key={component.id}
                      data-component-guid={component.id}
                      data-component-name={component.name}
                    >
                      <td>{component.name}</td>
                      <td>{component.seqNo}</td>

                      <td id={component.typeValue}>{component.typeText}</td>
                      <td>
                        <button
                          className="btn btn-xs btn-danger"
                          title="Delete"
                          onClick={() =>
                            deleteFormMasterComponent(component.id)
                          } // onClick calls the delete function
                          disabled={shouldDisableFields}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                        &nbsp;&nbsp;
                        {component.typeValue === 121440000 ||
                        component.typeValue === 121440001 ? null : (
                          <button
                            className="btn btn-xs btn-primary"
                            title="Edit"
                            onClick={() => handleEditButtonClick(component.id)} // onClick calls the delete function
                            disabled={shouldDisableFields}
                          >
                            <i className="fa fa-pen"></i>
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4">No components available.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </fieldset>
        )}
      </div>

      {/* Modal */}
      {modalVisible && (
        <div
          className="modal fade show modal-lg"
          style={{ display: "block", marginLeft: "450px" }}
          tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg" id="modal-default">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title" id="modal-default-label">
                  Add component
                </h4>
                <button
                  type="button"
                  className="close"
                  onClick={handleCloseModal}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div
                className="modal-body"
                style={{
                  maxHeight:
                    "400px" /* Adjust this value according to your needs */,
                  overflowY: "auto",
                }}
              >
                {renderModalContent()}
              </div>
              <div className="modal-footer justify-content-between">
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={handleCloseModal}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                >
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Modal */}
      {sectionModalVisible && (
        <div className="modal fade show" style={{ display: "block" }}>
          <div className="modal-dialog modal-sm">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Update Section</h4>
                <button
                  type="button"
                  className="close"
                  onClick={handleCloseSectionModal} // Close modal and clear fields
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                {selectedSectionId ? (
                  <div>
                    <div className="form-group">
                      <label htmlFor="columnsInput">No. of Columns:</label>
                      <input
                        id="columnsInput"
                        type="number"
                        className="form-control"
                        value={columns} // Bind to state for value
                        onChange={(e) => setColumns(e.target.value)} // Update state on change
                        min="0" // Minimum value allowed
                        max="4" // Maximum value allowed
                        step="1" // Steps in increments of
                      />
                    </div>
                  </div>
                ) : (
                  <p>Loading section details...</p>
                )}
              </div>
              <div className="modal-footer justify-content-between">
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={handleCloseSectionModal}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSectionSaveChanges}
                >
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FormMasterSectionCard;
